
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { FsAcl } from '@firestitch/acl';
import { FsSidenavModule, MENU_DATA, SidenavMenuRef } from '@firestitch/sidenav';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AclPermission } from '@common/enums';

import { CreateComponent } from '@app/environment/modules/create/components/create';

import { EnvironmentSwitchComponent } from '../environment-switch/environment-switch.component';


@Component({
    templateUrl: './environment-menu.component.html',
    styleUrls: ['./environment-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    RouterModule,
    FsSidenavModule
]
})
export class EnvironmentMenuComponent implements OnInit, OnDestroy {
  private _data = inject(MENU_DATA);
  private _dialog = inject(MatDialog);
  private _acl = inject(FsAcl);
  private _menuRef = inject<SidenavMenuRef<EnvironmentMenuComponent>>(SidenavMenuRef);


  public environment;
  public hasSettingsAccess;

  public hasAdminWritePermissions: boolean;

  private _destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.environment = this._data.environment;
    this.hasSettingsAccess = this._data.hasSettingsAccess;
    this.hasAdminWritePermissions = this._acl
      .hasWrite(AclPermission.Environment, this.environment?.id);
  }

  public close(): void {
    this._menuRef.close();
  }

  public create(): void {
    this.close();

    this._dialog.open(CreateComponent, {
      data: { autofocus: false },
    });
  }

  public switch(): void {
    this.close();
    this._dialog.open(EnvironmentSwitchComponent, {
      data: {},
    })
      .afterClosed()
      .pipe(
        filter((response) => !!response),
        takeUntil(this._destroy$),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
